import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enregistre le service worker (push + installabilité PWA). Sans cache → pas de
// risque de contenu périmé (voir sw-push.js). Voir CODEX §23/§24/§25.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-push.js').catch(() => {});
  });
}

// Badge d'icône : quand l'app est ouverte/visible, on remet la puce à zéro
// (effacement local + reset du compteur dans le service worker). Voir §25.
const clearAppBadge = () => {
  try { (navigator as any).clearAppBadge?.(); } catch { /* ignore */ }
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(reg => reg.active?.postMessage({ type: 'nslive-clear-badge' })).catch(() => {});
  }
};
window.addEventListener('load', clearAppBadge);
window.addEventListener('focus', clearAppBadge);
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') clearAppBadge(); });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
